import {useFormik} from 'formik'
import React, {useEffect, useState} from 'react'
import {Col, Modal, Row, Spinner, Stack} from 'react-bootstrap'
import {createPortal} from 'react-dom'
import SVG from 'react-inlinesvg'
import * as Yup from 'yup'
import {defaultProductDetails} from './AddProductInterface'
import closeSymbol from '../../../../../_metronic/images/closeSymbol.svg'
import {useLazyQuery, useMutation} from '@apollo/client'
import {
  GET_PRODUCT_DETAILS,
  CREATE_PRODUCT,
  GET_PRODUCT_BY_ID,
  UPDATE_PRODUCT,
  GET_ALL_SCRIPTS_LIST,
  S3_FILE_DELETE,
  GETCLIENTFEATUREFLAGS,
} from '../../../../../utils/GraphQLAPI'
import moment from 'moment'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import Dropdown from '../../../../sharedComponent/Dropdown/Dropdown'
import {alert, preventScroll, restrictDecimal, uploadFiles} from '../../../../../utils/helper'
import ElectricProperty from './AddProduct/ElectricProperty'
import './AddProduct/AddProduct.css'
import GasProperty from './AddProduct/GasProperty'

//validations
import {basicValidations, gasValidations, electricValidations} from './AddProductUtils'
import DragDrop from '../../../../sharedComponent/UploadDrag'
import {PdfPreview} from '../../../../sharedComponent/Preview'
import ToggleButton from '../../../../sharedComponent/ToggleButton'
import {GLOBAL_CONSTANTS} from '../../../../../utils/GlobalConstants'

const fileUploadFileType = ['pdf']
const MySwal = withReactContent(Swal)

type Props = {
  show: boolean
  handleClose: () => void
  method: string
  editId: string
  refetchProduct: () => void
}
const noteList = [{fieldName: 'note1', placeHolderText: 'Note 1'}]
const networkOnly = 'network-only'
const modalsRoot = document.getElementById('root-modals') || document.body

const AddProductModal = ({show, handleClose, method, editId, refetchProduct}: Props) => {
  const [brandData, setBrandData] = useState<any>()
  const [commodityData, setCommodityData] = useState<any>()
  const [utilityData, setUtilityData] = useState<any>()
  const [contractTypeData, setContractTypeData] = useState<any>()
  const [customerTypeData, setCustomerTypeData] = useState<any>()
  const [unitData, setUnitData] = useState<any>()
  const [productNotesServer, setProductNotesServer] = useState<any>([])
  const [status, setStatus] = useState<string>('Add')
  const [tpvScript, setTpvScript] = useState<any>([])
  const [activeStatus, setActiveStatus] = useState<any>(true)
  const [validationSchema, setValidationSchema] = useState<any>({
    ...basicValidations,
    ...electricValidations,
  })
  const [commodity, setCommodity] = useState('Electric')
  const [TC, setTC] = useState<File | null>(null)
  const [EFL, setEFL] = useState<File | null>(null)
  const [otherFile, setOtherFile] = useState<File | null>(null)

  const [submitting, setSubmitting] = useState(false)
  useEffect(() => {
    if (commodity === 'Dual') {
      setValidationSchema({
        ...basicValidations,
        ...electricValidations,
        ...gasValidations,
      })
    } else if (commodity === 'Electric') {
      setValidationSchema({
        ...basicValidations,
        ...electricValidations,
      })
    } else if (commodity === 'Gas') {
      setValidationSchema({
        ...basicValidations,
        ...gasValidations,
      })
    }
  }, [commodity])
  useEffect(() => {
    if (method === 'Create') {
      formik.setValues({...defaultProductDetails})
      setStatus('Add')
      setActiveStatus(true)
      setCommodity('Electric')
    } else if (method === 'edit' || method === 'clone') {
      getProductById()
      setStatus(method === 'edit' ? 'Edit' : 'Clone')
    }
    getClientFeatureFlags()
    getCustomerData()
    getAllScripts()
    formik.resetForm()
  }, [editId, method, show])
  console.log(status)
  const [getClientFeatureFlags, {data: featureFlags}] = useLazyQuery(GETCLIENTFEATUREFLAGS, {
    fetchPolicy: 'network-only',
  })
  const [getCustomerData] = useLazyQuery(GET_PRODUCT_DETAILS, {
    onCompleted: (data) => {
      setCommodityData(data?.getProductDetail[0]?.names)
      setUtilityData(data?.getProductDetail[1]?.names)
      setUnitData(data?.getProductDetail[2]?.names)
      setBrandData(data?.getProductDetail[3]?.names)
      setCustomerTypeData(data?.getProductDetail[4]?.names)
      setContractTypeData(data?.getProductDetail[5]?.names)
    },
    fetchPolicy: networkOnly,
  })

  const [getAllScripts] = useLazyQuery(GET_ALL_SCRIPTS_LIST, {
    fetchPolicy: networkOnly,
    variables: {
      getScriptsInput: {
        commodityId: null,
        isActive: true,
        languageId: null,
        salesChannelId: null,
        searchText: '',
        utilityId: null,
      },
    },
    onCompleted: (data) => {
      setTpvScript(data.getAllScripts.scripts)
    },
  })
  const [addProduct] = useMutation(CREATE_PRODUCT, {
    fetchPolicy: GLOBAL_CONSTANTS.networkOnlyMutation,
    onCompleted: () => {
      alert('Product added successfully', 'success')
      handleModalClose()
      refetchProduct()
      setCommodity('Electric')
      handleModalClose()
      setSubmitting(false)
    },
    onError: (e) => {
      alert(e.message, 'error')
      setSubmitting(false)
    },
  })

  const [updateProduct] = useMutation(UPDATE_PRODUCT, {
    fetchPolicy: networkOnly,
    onCompleted: (data) => {
      const options: any = {
        customClass: {
          popup: 'swal2-border-radius',
        },
        title: 'Product updated successfully',
        icon: 'success',
        confirmButtonColor: '#3E97FF',
      }
      MySwal.fire(options)
      refetchProduct()
      setCommodity('Electric')
      handleModalClose()
      setSubmitting(false)
    },
    onError: (e) => {
      alert(e.message, 'error')
      setSubmitting(false)
    },
  })

  const [deleteFileFromS3] = useLazyQuery(S3_FILE_DELETE)
  const handleSelectedItem = (e: any, name: any) => {
    if (e.value.length > 0) {
      formik.setFieldValue(name, e.label)
      formik.setFieldValue(`${name}Id`, e.value)
    } else {
      formik.setFieldValue(name, '')
      formik.setFieldValue(`${name}Id`, null)
    }
  }

  const [getProductById, {data: getProductByIdData, loading}] = useLazyQuery(GET_PRODUCT_BY_ID, {
    fetchPolicy: networkOnly,
    variables: {
      id: editId,
    },
    onCompleted: (productData) => {
      const editProductEnrollment = {
        id: productData.getProductById.id,
        productName: productData.getProductById.name || '',
        productCode: productData.getProductById.code || '',
        brand: productData.getProductById.brandType
          ? productData.getProductById.brandType.name
          : '',
        brandId: productData.getProductById.brandTypeId,
        productBrandId: productData.getProductById.brandType
          ? productData.getProductById.brandType.id
          : '',
        commodity: productData.getProductById.commodity
          ? productData.getProductById.commodity.name
          : '',
        commodityId: productData.getProductById.commodity
          ? productData.getProductById.commodity.id
          : '',
        ebillingMethod: Boolean(productData.getProductById.ebillingMethod)
          ? productData.getProductById.ebillingMethod
          : '',
        ecode: productData.getProductById.ecode ? productData.getProductById.ecode : '',
        utility: productData.getProductById.utility ? productData.getProductById.utility.name : '',
        utilityId: productData.getProductById.utility ? productData.getProductById.utility.id : '',
        contractType: productData.getProductById.contractType
          ? productData.getProductById.contractType.name
          : '',
        contractTypeId: productData.getProductById.contractType
          ? productData.getProductById.contractType.id
          : '',
        customerType: productData.getProductById.customerType
          ? productData.getProductById.customerType.name
          : '',
        customerTypeId: productData.getProductById.customerType
          ? productData.getProductById.customerType.id
          : '',
        unit: productData.getProductById.unit || '',
        rate: String(productData.getProductById.rate) || '',
        secondRate: productData.getProductById.secondRate || '',
        term: productData.getProductById.term || '',
        earlyTerminationFee: productData.getProductById.earlyTerminationFee || '',
        serviceFee: productData.getProductById.serviceFee || '',
        added: productData.getProductById.adder || '',
        language: '',
        script: productData.getProductById.script ? productData.getProductById.script.name : '',
        scriptId: productData.getProductById.script
          ? productData.getProductById.script.scriptId
          : '',
        prodScriptId: productData.getProductById.prodScriptId
          ? productData.getProductById.prodScriptId
          : '',
        deposit: productData.getProductById.deposit || '',
        gutility: productData.getProductById.gutility
          ? productData.getProductById.gutility.name
          : '',
        gutilityId: productData.getProductById.gutility
          ? productData.getProductById.gutility.id
          : '',
        gcontractType: productData.getProductById.gcontractType
          ? productData.getProductById.gcontractType.name
          : '',
        gcontractTypeId: productData.getProductById.gcontractType
          ? productData.getProductById.gcontractType.id
          : '',
        gunit: productData.getProductById.gunit || '',
        gunitId: productData.getProductById.gunitTypeId,
        grate: String(productData.getProductById.grate) || '',
        gsecondRate: productData.getProductById.gsecondRate || '',
        gterm: productData.getProductById.gterm || '',
        gearlyTerminationFee: productData.getProductById.gearlyTerminationFee || '',
        gserviceFee: productData.getProductById.gserviceFee || '',
        gadded: productData.getProductById.gadder || '',
        gdeposit: productData.getProductById.gdeposit || '',
        gbillingMethod: Boolean(productData.getProductById.gbillingMethod)
          ? productData.getProductById.gbillingMethod
          : '',
        gcode: productData.getProductById.gcode,
        startDate: Boolean(productData.getProductById.startDate)
          ? new Date(productData.getProductById.startDate)
          : null,
        endDate: Boolean(productData.getProductById.endDate)
          ? new Date(productData.getProductById.endDate)
          : null,
        note1: Boolean(productData.getProductById.notes) ? productData.getProductById.notes : null,
      }
      setProductNotesServer(
        productData.getProductById.productNotes ? productData.getProductById.productNotes : []
      )
      setTC(
        productData.getProductById?.productFiles.filter((file: any) => file?.position === 0)[0]
          ?.fileUrl
      )
      setEFL(
        productData.getProductById?.productFiles.filter((file: any) => file?.position === 1)[0]
          ?.fileUrl
      )
      setOtherFile(
        productData.getProductById?.productFiles.filter((file: any) => file?.position === 2)[0]
          ?.fileUrl
      )
      formik.setValues({...editProductEnrollment})
      productData.getProductById?.productType &&
        setCommodity(productData.getProductById?.productType)
      setActiveStatus(productData.getProductById.isActive ? true : false)
    },
  })

  const getProductNotes = (values: any) => {
    const noteLimit = 5
    const productNoteArray = []
    for (let i = 1; i <= noteLimit; i++) {
      const obj: any = {}
      obj.position = i
      obj.description = values['note' + i]
      productNoteArray.push(obj)
    }
    return productNoteArray
  }

  const getProductNotesEdit = (values: any) => {
    if (productNotesServer.length > 0) {
      return productNotesServer.map((each: any) => {
        each.description = values['note' + each.position]
        delete each.__typename
        return each
      })
    } else {
      return []
    }
  }

  const formik: any = useFormik({
    initialValues: defaultProductDetails,
    validationSchema: Yup.object().shape(validationSchema),
    enableReinitialize: true,
    onSubmit: async (values) => {
      setSubmitting(true)
      let formData: any = {
        name: values.productName,
        brandTypeId: Boolean(values.brandId) ? values.brandId : null,
        commodityId:
          commodity === 'Electric'
            ? commodityData.filter((item: any) => item.value === 'Electric')[0]?.id
            : formik.getFieldMeta('commodityId').value,

        customerTypeId: formik.getFieldMeta('customerTypeId').value || null,
        description: '',
        //languageId : formik.getFieldMeta('languageId').value,
        isActive: activeStatus,
        productType: commodity.toUpperCase(),
        ...(values.startDate
          ? {startDate: moment.utc(values.startDate).format()}
          : {startDate: null}),
        ...(values.endDate ? {endDate: moment.utc(values.endDate).format()} : {endDate: null}),
      }
      if (commodity === 'Electric') {
        formData = {
          ...formData,
          unitTypeId: formik.getFieldMeta('unitId').value,
          contractTypeId: formik.getFieldMeta('contractTypeId').value || null,
          deposit: !Boolean(values.deposit) ? null : Number(values.deposit),
          earlyTerminationFee: !Boolean(values.earlyTerminationFee)
            ? null
            : Number(values.earlyTerminationFee),
          adder: values.added === '' ? null : Number(values.added),
          rate: Number(values.rate),
          secondRate: !Boolean(values.secondRate) ? null : Number(values.secondRate),
          serviceFee: !Boolean(values.serviceFee) ? null : Number(values.serviceFee),
          term: values.term,
          unit: values.unit,
          utilityId: formik.getFieldMeta('utilityId').value,
          ecode: values.ecode,
          ebillingMethod: values.ebillingMethod,
        }
      } else if (commodity === 'Gas') {
        formData = {
          ...formData,
          gdeposit: !Boolean(values.gdeposit) ? null : Number(values.gdeposit),
          gearlyTerminationFee: !Boolean(values.gearlyTerminationFee)
            ? null
            : Number(values.gearlyTerminationFee),
          gadder: values.gadded === '' ? null : Number(values.gadded),
          grate: Number(values.grate),
          gsecondRate: !Boolean(values.gsecondRate) ? null : Number(values.gsecondRate),
          gserviceFee: !Boolean(values.gserviceFee) ? null : Number(values.gserviceFee),
          gterm: values.gterm,
          gunit: values.gunit,
          gunitTypeId: values.gunitId,
          gutilityId: formik.getFieldMeta('gutilityId').value,
          gcontractTypeId: formik.getFieldMeta('gcontractTypeId').value || null,
          gcode: values.gcode,
          gbillingMethod: values.gbillingMethod,
        }
      } else if (commodity === 'Dual') {
        formData = {
          ...formData,
          unitTypeId: formik.getFieldMeta('unitId').value,
          contractTypeId: formik.getFieldMeta('contractTypeId').value || null,
          deposit: !Boolean(values.deposit) ? null : Number(values.deposit),
          earlyTerminationFee: !Boolean(values.earlyTerminationFee)
            ? null
            : Number(values.earlyTerminationFee),
          adder: values.added === '' ? null : Number(values.added),
          rate: Number(values.rate),
          secondRate: !Boolean(values.secondRate) ? null : Number(values.secondRate),
          serviceFee: !Boolean(values.serviceFee) ? null : Number(values.serviceFee),
          term: values.term,
          unit: values.unit,
          utilityId: formik.getFieldMeta('utilityId').value,
          ecode: values.ecode,
          ebillingMethod: values.ebillingMethod,
          gdeposit: !Boolean(values.gdeposit) ? null : Number(values.gdeposit),
          gearlyTerminationFee: !Boolean(values.gearlyTerminationFee)
            ? null
            : Number(values.gearlyTerminationFee),
          gadder: values.gadded === '' ? null : Number(values.gadded),
          grate: Number(values.grate),
          gsecondRate: !Boolean(values.gsecondRate) ? null : Number(values.gsecondRate),
          gserviceFee: !Boolean(values.gserviceFee) ? null : Number(values.gserviceFee),
          gterm: values.gterm,
          gunit: values.gunit,
          gunitTypeId: values.gunitId,
          gutilityId: formik.getFieldMeta('gutilityId').value,
          gcontractTypeId: formik.getFieldMeta('gcontractTypeId').value || null,
          gcode: values.gcode,
          gbillingMethod: values.gbillingMethod,
          ...(values.startDate
            ? {startDate: moment.utc(values.startDate).format()}
            : {startDate: null}),
          ...(values.endDate ? {endDate: moment.utc(values.endDate).format()} : {endDate: null}),
        }
      }
      if (method === 'Create' || method === 'clone') {
        let TCUrl, EFLUrl, OtherUrl
        let productFiles = []
        if (method === 'clone') {
          console.log('tceflother---', TC, EFL, otherFile)
          productFiles = getProductByIdData?.getProductById?.productFiles.map((data: any) => ({
            fileUrl: data.fileUrl,
            position: data.position,
          }))
        }
        if (method === 'Create') {
          if (Boolean(TC)) {
            TCUrl = await uploadFiles(
              [TC],
              false,
              '',
              `Productfiles/${values.productName.replaceAll(' ', '-')}`
            )
            console.log('TCURL----', TCUrl)
            productFiles.push({
              fileUrl: TCUrl[0],
              position: 0,
            })
          }
          if (EFL) {
            EFLUrl = await uploadFiles(
              [EFL],
              false,
              '',
              `Productfiles/${values.productName.replaceAll(' ', '-')}`
            )
            productFiles.push({
              fileUrl: EFLUrl[0],
              position: 1,
            })
          }
          if (otherFile) {
            OtherUrl = await uploadFiles(
              [otherFile],
              false,
              '',
              `Productfiles/${values.productName.replaceAll(' ', '-')}`
            )
            productFiles.push({
              fileUrl: OtherUrl[0],
              position: 2,
            })
          }
        }

        await addProduct({
          variables: {
            createProductInput: {
              ...formData,
              notes: values.note1,
              // productNotes: getProductNotes(values),
              scriptId: formik.getFieldMeta('scriptId').value,
              productFiles,
              ...(values.startDate
                ? {startDate: moment.utc(values.startDate).format()}
                : {startDate: new Date(moment.utc().format())}),
            },
          },
        })
      } else if (method === 'edit') {
        const TCSameAsApiData =
          getProductByIdData.getProductById?.productFiles.filter(
            (file: any) => file?.position === 0
          )[0]?.fileUrl === TC
        const productFiles = []
        let TCUrl, EFLUrl, OtherUrl
        if (!TCSameAsApiData) {
          if (TC) {
            TCUrl = await uploadFiles(
              [TC],
              false,
              '',
              `Productfiles/${values.productName.replaceAll(' ', '-')}`
            )
            productFiles.push({
              fileUrl: TCUrl[0],
              position: 0,
            })
          } else {
            productFiles.push({
              fileUrl: '',
              isDelete: true,
              position: 0,
            })
          }
        }
        const EFLSameAsApiData =
          getProductByIdData.getProductById?.productFiles.filter(
            (file: any) => file?.position === 1
          )[0]?.fileUrl === EFL
        if (!EFLSameAsApiData) {
          if (EFL) {
            EFLUrl = await uploadFiles(
              [EFL],
              false,
              '',
              `Productfiles/${values.productName.replaceAll(' ', '-')}`
            )
            productFiles.push({
              fileUrl: EFLUrl[0],
              position: 1,
            })
          } else {
            productFiles.push({
              fileUrl: '',
              isDelete: true,
              position: 1,
            })
          }
        }
        const OtherSameAsAPiData =
          getProductByIdData.getProductById?.productFiles.filter(
            (file: any) => file?.position === 2
          )[0]?.fileUrl === otherFile
        if (!OtherSameAsAPiData) {
          if (otherFile) {
            OtherUrl = await uploadFiles(
              [otherFile],
              false,
              '',
              `Productfiles/${values.productName.replaceAll(' ', '-')}`
            )
            productFiles.push({
              fileUrl: OtherUrl[0],
              position: 2,
            })
          } else {
            productFiles.push({
              fileUrl: '',
              isDelete: true,
              position: 2,
            })
          }
        }
        await updateProduct({
          variables: {
            updateProductInput: {
              ...formData,
              id: formik.getFieldMeta('id').value,
              productFiles,
              notes: values.note1,
              ...(formik.getFieldMeta('scriptId').value !== '' && {
                scriptId: formik.getFieldMeta('scriptId').value,
              }),
              ...(formik.getFieldMeta('prodScriptId').value !== '' && {
                prodScriptId: formik.getFieldMeta('prodScriptId').value,
              }),
            },
          },
        })
      }
    },
  })
  console.log(formik)
  useEffect(() => {
    if (!formik.isSubmitting) {
      return
    }
    if (Object.keys(formik.errors).length > 0) {
      const errorElement = document.getElementById(Object.keys(formik.errors)[0])
      errorElement?.scrollIntoView({behavior: 'smooth', block: 'center'})
      errorElement?.focus({preventScroll: true})
    }
  }, [formik])

  const handleModalClose = () => {
    setCommodity('Electric')
    setTC(null)
    setEFL(null)
    setOtherFile(null)
    handleClose()
  }
  console.log(formik)
  return createPortal(
    <Modal
      id='kt-modal_create_app'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog modal-dialog-centered mw-650px'
      show={show}
      onHide={() => handleModalClose()}
      backdrop={true}
    >
      <div className='modal-header'>
        <h2>{status} Product</h2>
        <div className='d-flex'>
          <ToggleButton
            leftText='Inactive'
            rightText='Active'
            leftTextClassName='badge-light-danger'
            rightTextClassName='badge-light-success'
            isActive={activeStatus}
            onChange={(checked) => setActiveStatus(checked)}
          />
          <div
            className='btn btn-sm btn-icon btn-active-color-primary'
            onClick={() => handleModalClose()}
          >
            <SVG src={closeSymbol}></SVG>
          </div>
        </div>
      </div>
      <div className='hover-scroll-overlay-y mh-550px product-form'>
        {loading ? (
          <div className='text-center mh-400px'>
            <Spinner animation='border' className='text-gray-600 text-center' role='status'>
              <span className='visually-hidden'>Loading...</span>
            </Spinner>
          </div>
        ) : (
          <div className='mh-450px overflow-auto modal-body mx-10 ps-8 pe-2 py-0'>
            <Row className='d-flex align-items-start mt-5 no-gutters noPadding mb-5'>
              {/* Product Name */}
              <Col sm md lg={6}>
                <label className='d-flex align-items-center mb-2 required'>
                  <span className='fs-6 fw-semibold lh-23'>Product Name</span>
                </label>
                <input
                  type='text'
                  className='form-control form-control-lg form-control-solid'
                  placeholder='Enter product name'
                  id='productName'
                  maxLength={51}
                  {...formik.getFieldProps('productName')}
                />
                {formik.errors.productName && formik.touched.productName && (
                  <div className='fv-plugins-message-container'>
                    <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                      {formik.errors.productName}
                    </div>
                  </div>
                )}
              </Col>
              {/* Brand */}
              <Col sm md lg={6}>
                <label className='d-flex align-items-center mb-2'>
                  <span className='fs-6 fw-semibold lh-23'>Brand</span>
                </label>
                <Dropdown
                  fieldName='brand'
                  optionList={brandData}
                  handleSelectedItem={handleSelectedItem}
                  formik={formik}
                />
              </Col>
            </Row>

            <Row className='d-flex align-items-start mt-5 no-gutters noPadding mb-5'>
              {/* Commodity */}
              <Col sm md lg={6}>
                <label className='d-flex align-items-center mb-2'>
                  <span className='fs-6 fw-semibold lh-23'>Commodity</span>
                </label>
                <select
                  id='Commodity'
                  aria-label='select brand'
                  className='form-select form-select-solid'
                  value={commodity}
                  onChange={(e) => {
                    // console.log(e)
                    setCommodity(e.target.value)
                    formik.setFieldValue('commodity', e.target.value)
                    formik.setFieldValue(
                      'commodityId',
                      commodityData.filter((item: any) => item.value === e.target.value)[0]?.id
                    )
                  }}
                >
                  {commodityData?.map(({id, value}: any) => (
                    <option value={value} id={id}>
                      {value}
                    </option>
                  ))}
                </select>
              </Col>
              <Col sm md lg={6}>
                <label className='d-flex align-items-center mb-2 required'>
                  <span className='fs-6 fw-semibold lh-23'>Customer Type</span>
                </label>
                <Dropdown
                  fieldName='customerType'
                  optionList={customerTypeData}
                  handleSelectedItem={handleSelectedItem}
                  formik={formik}
                />
              </Col>
            </Row>
            {(commodity === 'Electric' || commodity === 'Dual') && (
              <ElectricProperty
                utilityData={utilityData}
                handleSelectedItem={handleSelectedItem}
                formik={formik}
                contractTypeData={contractTypeData}
                restrictDecimal={restrictDecimal}
                preventScroll={preventScroll}
                unitData={unitData}
              />
            )}
            {(commodity === 'Gas' || commodity === 'Dual') && (
              <GasProperty
                utilityData={utilityData}
                handleSelectedItem={handleSelectedItem}
                formik={formik}
                contractTypeData={contractTypeData}
                restrictDecimal={restrictDecimal}
                preventScroll={preventScroll}
                unitData={unitData}
              />
            )}

            <Row className='d-flex align-items-start mt-5 no-gutters noPadding mb-5'>
              <Col sm md lg={6}>
                <label className='d-flex align-items-center mb-2'>
                  <span className='fs-6 fw-semibold lh-23'>Start Date</span>
                </label>
                <DatePicker
                  className='form-control form-control-solid ps-6'
                  id={'startDate'}
                  minDate={new Date()}
                  maxDate={formik.getFieldProps('endDate').value}
                  selected={formik.getFieldProps('startDate').value}
                  onChange={(val) => formik.setFieldValue('startDate', val)}
                  dateFormat='MM-dd-yyyy'
                  autoComplete='off'
                  placeholderText='MM-DD-YYYY'
                />
                {formik.errors.startDate && (
                  <div className='fv-plugins-message-container'>
                    <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                      {formik.errors.startDate}
                    </div>
                  </div>
                )}
              </Col>
              <Col sm md lg={6}>
                <label className='d-flex align-items-center mb-2'>
                  <span className='fs-6 fw-semibold lh-23'>End Date</span>
                </label>
                <DatePicker
                  className='form-control form-control-solid ps-6'
                  id={'endDate'}
                  minDate={formik.getFieldProps('startDate').value}
                  selected={formik.getFieldProps('endDate').value}
                  onChange={(val) => formik.setFieldValue('endDate', val)}
                  dateFormat='MM-dd-yyyy'
                  autoComplete='off'
                  placeholderText='MM-DD-YYYY'
                />
                {formik.errors.added && (
                  <div className='fv-plugins-message-container'>
                    <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                      {formik.errors.endDate}
                    </div>
                  </div>
                )}
              </Col>
            </Row>
            <Row className='d-flex align-items-start mt-5 no-gutters noPadding mb-5'>
              <Col sm md lg={6}>
                <label className='d-flex align-items-center mb-2'>
                  <span className='fs-6 fw-semibold lh-23'>Assign to TPV Script</span>
                </label>
                <Dropdown
                  fieldName='script'
                  optionList={tpvScript}
                  handleSelectedItem={handleSelectedItem}
                  formik={formik}
                />
              </Col>
              {/* Unit */}
            </Row>
            <div>
              <label className='d-flex align-items-center mb-2'>
                <span className='fs-6 fw-semibold lh-23'>Additional Information</span>
              </label>
              <Row className='d-flex align-items-start mt-5 no-gutters noPadding mb-5'>
                <Col sm md lg={12}>
                  <Stack gap={4}>
                    {noteList.map((noteItem: any, index: number) => {
                      return (
                        <div key={index}>
                          <input
                            type='text'
                            id={noteItem.fieldName}
                            placeholder={noteItem.placeHolderText}
                            className='form-control form-control-solid'
                            {...formik.getFieldProps(noteItem.fieldName)}
                          />
                        </div>
                      )
                    })}
                  </Stack>
                </Col>
              </Row>
            </div>
            {(featureFlags?.getClientFeatureFlags?.enableSmsDocumentVerification ||
              featureFlags?.getClientFeatureFlags?.enableEmailDocumentVerification) && (
              <>
                <p className='fw-semibold fs-6 mt-3'>Terms and Conditions</p>
                {TC ? (
                  <PdfPreview url={TC} isViewable removeFile={() => setTC(null)} />
                ) : (
                  <DragDrop
                    fileTypes={fileUploadFileType}
                    setFile={setTC}
                    label={'Click here to upload terms and conditions or drag and drop'}
                  />
                )}
                <p className='fw-semibold fs-6 mt-3'>Disclosure Statement</p>
                {EFL ? (
                  <PdfPreview url={EFL} isViewable removeFile={() => setEFL(null)} />
                ) : (
                  <DragDrop
                    fileTypes={fileUploadFileType}
                    setFile={setEFL}
                    label={'Click here to upload EFL or drag and drop'}
                  />
                )}

                <p className='fw-semibold fs-6 mt-3'>Other</p>
                {otherFile ? (
                  <PdfPreview url={otherFile} isViewable removeFile={() => setOtherFile(null)} />
                ) : (
                  <DragDrop
                    fileTypes={fileUploadFileType}
                    setFile={setOtherFile}
                    label={'Click here to upload other or drag and drop'}
                  />
                )}
              </>
            )}
          </div>
        )}

        <div
          className='modal-footer sticky-bottom bg-white'
          style={{borderRadius: '0 0 20px 20px', zIndex: '2'}}
        >
          <button type='button' className='btn btn-light' onClick={() => handleModalClose()}>
            Discard
          </button>
          <button
            className={'btn btn-primary'}
            data-kt-stepper-action='submit'
            onClick={(e) => formik.submitForm()}
          >
            {submitting
              ? method === 'Create'
                ? 'Creating product'
                : 'Updating product'
              : 'Submit'}
            {submitting && (
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            )}
          </button>
        </div>
      </div>
    </Modal>,
    modalsRoot
  )
}

export {AddProductModal}
